import PlansBlockPreview from "./PlansBlockPreview";

export default PlansBlockPreview;